module.exports = __webpack_public_path__ + "img/we-craft-apps.b8575865.png";